import React from 'react'
import USTemplateDefault from 'src/components/template/us'
import { commonTitleText } from 'src/modules/utils/constants'
export default (props) => (
  <USTemplateDefault
    location={props.location}
    lang="en"
    market="us"
    title={commonTitleText.streamLiveTVSports}
    subtitle={
      <>
        Enjoy a special offer through New Jersey Transit.
        <br />
        Save $40 off your first month.
      </>
    }
    hasOfferInput={true}
    noIndex={true}
  />
)
